export default "__VITE_ASSET__BLc2iby6__"